module.exports = "<div class=\"loading\">\n  <img src=\"assets/images/loading.svg\" alt=\"loading\">\n</div>\n"